import { connect } from 'react-redux';
import { selectRouteParams } from 'selectors/general';
import { goToItem as goToItemAction } from '../../ManageServices.saga';
import PractitionersListItem from './PractitionersListItem';

function mapStateToProps(state, ownProps) {
  const { itemId } = selectRouteParams(state);
  return {
    ...ownProps,
    selectedPractitionerId: itemId,
  };
}

const mapDispatchToProps = {
  goToItem: goToItemAction,
};

function mergeProps(stateProps, dispatchProps) {
  const { id } = stateProps;
  const { goToItem } = dispatchProps;
  return {
    ...stateProps,
    goToItem: goToItem.bind(null, id),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PractitionersListItem);
